import './index.scss'
import { skills } from '../../data/skills'

const SkillsPage = () => {
  return (
    <main className="skills-page">
      <div className="site-container">
      <section className="skills-hero">
        <div className="skills-hero__content">
          <p className="eyebrow">Skills</p>
          <h1>Technical skills and strengths</h1>
          <h2>Languages, frameworks, and core computer science knowledge</h2>
          <p>
            I have developed experience across programming, web development, databases, machine learning, and systems thinking through both academic work and project-based development.
          </p>
        </div>
      </section>

      <section className="skills-grid">
        {skills.map((group) => (
          <article className="skill-card" key={group.category}>
            <h3>{group.category}</h3>
            <ul>
              {group.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
        ))}
      </section>
      </div>
    </main>
  )
}

export default SkillsPage
